import { getStateWithOnlyOneLevel } from '../../utils/StateSelectorHelper';

// general state
function getDashboardState(state) {
  return getStateWithOnlyOneLevel(state, 'dashboard');
}

export const getShowPdfViewer = (state) =>
  getDashboardState(state).get('showPdfViewer');

export const getDashboardHeaderInfo = (state) =>
  getDashboardState(state).get('dashboardHeaderInfo');

export const getDashboardHeaderInfoWaiting = (state) =>
  getDashboardState(state).get('dashboardHeaderInfoWaiting');

export const getUpdateCycleMessage = (state) =>
  getDashboardState(state).get('setUpdateCycleMessage');

// for myStats state
function getStatsState(state) {
  return getStateWithOnlyOneLevel(state, 'myStats');
}

export const getStats = (state) => getStatsState(state).get('myStatsData');

function getoneDailyQuizHistory(state) {
  return getStateWithOnlyOneLevel(state, 'oneDailyQuizHistory');
}

export const oneDailyQuizHistory = (state) =>
  getoneDailyQuizHistory(state).get('oneDailyQuizHistory');

export const oneQualDailyQuizHistory = (state) =>
  getoneDailyQuizHistory(state).get('oneQualDailyQuizHistory');

export const getLoginStreak = (state) =>
  getStatsState(state).get('loginStreak');

export const getLongestLoginStreak = (state) =>
  getStatsState(state).get('longestLoginStreak');

export const getPointsThisWeek = (state) =>
  getStatsState(state).get('pointsThisWeek');

export const getRank = (state) => getStatsState(state).get('rank');

export const getLoadPointsThisWeekWaiting = (state) =>
  getStatsState(state).get('pointsThisWeekWaiting');

// for activity state

function getActivityState(state) {
  return getStateWithOnlyOneLevel(state, 'activity');
}

export const getActivity = (state) =>
  getActivityState(state).get('activityData');

// for leaderboard
function getLeaderboardState(state) {
  return getStateWithOnlyOneLevel(state, 'leaderboard');
}

export const getAllLeaderboardState = (state) =>
  getStateWithOnlyOneLevel(state, 'leaderboard');

export const getFriendLeaderboard = (state) =>
  getLeaderboardState(state).get('friendLeaderboard');

export const getEveryoneLeaderboard = (state) =>
  getLeaderboardState(state).get('everyoneLeaderboard');

export const getEveryoneLeaderboardWaiting = (state) =>
  getLeaderboardState(state).get('everyoneLeaderboardWaiting');

export const getFriendLeaderboardWaiting = (state) =>
  getLeaderboardState(state).get('friendLeaderboardWaiting');

// for badges state
function getBadgesState(state) {
  return getStateWithOnlyOneLevel(state, 'badges');
}

export const getBadgesSelector = (state) => getBadgesState(state).get('badges');

// for Daily Quiz History state
function getDailyQuizHistoryState(state) {
  return getStateWithOnlyOneLevel(state, 'dailyQuizHistory');
}

export const getDailyQuizHistorySelector = (state) =>
  getDailyQuizHistoryState(state).get('dailyHistory');

export const getQualDailyQuizHistorySelector = (state) =>
  getDailyQuizHistoryState(state).get('qualDailyQuizHistory');

export const getIsLoadingDailyQuizHistory = (state) =>
  getDailyQuizHistoryState(state).get('loadingDailyHistory');

export const getIsQualDailyQuizHistoryLoadingSelector = (state) =>
  getDailyQuizHistoryState(state).get('isQualDailyQuizHistoryLoading');

export const getLoadingReviewDailyQuiz = (state) =>
  getDailyQuizHistoryState(state).get('loadingReviewDailyQuiz');

export const getLoadingReviewQualDailyQuiz = (state) =>
  getDailyQuizHistoryState(state).get('loadingReviewQualDailyQuiz');

// for Practice Exam History state
function getPracticeExamHistoryState(state) {
  return getStateWithOnlyOneLevel(state, 'practiceExamHistory');
}

export const getPracticeExamsSelector = (state) =>
  getPracticeExamHistoryState(state).get('practiceExamHistory').exams;
export const getNextWeeklyGenerationAt = (state) =>
  getPracticeExamHistoryState(state).get('practiceExamHistory')
    .nextWeeklyGenerationAt;
export const getWeeklyPracticeExamBuildInProgress = (state) =>
  getPracticeExamHistoryState(state).get('practiceExamHistory')
    .weeklyPracticeExamBuildInProgress;
export const getIsLoadingPEHistory = (state) =>
  getPracticeExamHistoryState(state).get('loadingPracticeExamHistory');
export const getCustomPracticeExamHistory = (state) =>
  getPracticeExamHistoryState(state).get('customPracticeExamHistory');

// for Recomended Topics state
function getRecomendedTopicsState(state) {
  return getStateWithOnlyOneLevel(state, 'recomendedTopics');
}

export const getRecomendedTopicsSelector = (state) =>
  getRecomendedTopicsState(state).get('recomendedTopics');

// for Featured Blog state
function getFeaturedBlogState(state) {
  return getStateWithOnlyOneLevel(state, 'DashboardFeaturedBlog');
}

export const getFeaturedBlogSelector = (state) =>
  getFeaturedBlogState(state).get('featuredBlog');

export const getFeaturedBlogIsLoading = (state) =>
  getFeaturedBlogState(state).get('loadingFeaturedBlog');

// for Featured Forum state
function getFeaturedForumState(state) {
  return getStateWithOnlyOneLevel(state, 'featuredForum');
}

export const getFeaturedForumSelector = (state) =>
  getFeaturedForumState(state).get('featuredForum');

// for Featured Podcast state
function getFeaturedPodcastState(state) {
  return getStateWithOnlyOneLevel(state, 'featuredPodcast');
}

export const getFeaturedPodcastSelector = (state) =>
  getFeaturedPodcastState(state).get('featuredPodcast');

// for Invite a Friend state
function getInviteAFriendState(state) {
  return getStateWithOnlyOneLevel(state, 'inviteAFriend');
}

export const getInviteAFriendSelector = (state) =>
  getInviteAFriendState(state).get('response');

// for scoring History
function getScoringHistoryState(state) {
  return getStateWithOnlyOneLevel(state, 'scoringHistory');
}

export const getScoringHistorySelector = (state) =>
  getScoringHistoryState(state).get('scoringHistory');

export const getLoadingScoringHistory = (state) =>
  getScoringHistoryState(state).get('loading');
